/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList";
import themeConfig from "@/../themeConfig.js";
import colors from "@/../themeConfig.js";

// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const userDefaults = {
  uid: 0, // From Auth
  displayName: "John Doe", // From Auth
  about:
    "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL: require("@/assets/images/portrait/small/noavatar.svg"), // From Auth
  status: "online",
  userRole: "admin"
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: userDefaults,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList["pages"].data.filter(
    page => page.is_bookmarked
  ),
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  usageSettings: {
    fromDate: null,
    toDate: null,
    interval: "Hour",
    unity: "Money",
    triggerNewData: { trigger: null }
  },
  minMaxDate: [],
  customerStatus: null,
  contracts: null,
  mutationRequests: [],
  customer: {},
  actions: [],
  error: null,
  loading: 0,
  unreadNotifications: [
    // {
    //   index: 0,
    //   title: "Meterstand Doorgeven",
    //   msg: "Are your going to meet me tonight?",
    //   icon: "ThermometerIcon",
    //   time: new Date(),
    //   category: "primary"
    // },
    // {
    //   index: 1,
    //   title: "Nieuw Contract Kiezen",
    //   msg: "You got new order of goods.",
    //   icon: "BriefcaseIcon",
    //   time: new Date(),
    //   category: "success"
    // }
  ],
  navMenuItems: [
    {
      url: "/",
      name: "Overzicht",
      slug: "home",
      icon: "HomeIcon"
    },
    {
      url: "/profile",
      name: "Profiel",
      slug: "profile",
      icon: "UserIcon",
      submenu: [
        {
          url: "/profile?tab=personal",
          name: "Persoonlijke gegevens",
          slug: "profile-personal",
          icon: "UserIcon"
        },
        {
          url: "/profile?tab=payment",
          name: "Betalingsgegevens",
          slug: "profile-payment",
          icon: "DollarIcon"
        },
        {
          url: "/profile?tab=documents",
          name: "Documenten",
          slug: "profile-documents",
          icon: "FileIcon"
        }
      ]
    },
    {
      url: "/contracts",
      name: "Contracten",
      slug: "contracts",
      icon: "FileTextIcon"
    },
    {
      url: "/invoices",
      name: "Betalingen",
      slug: "invoices",
      icon: "DollarSignIcon"
    },
    {
      url: "/prices",
      name: "Tarieven",
      slug: "prices",
      icon: "DollarSignIcon"
    }
    // {
    //   url: "/documents",
    //   name: "Documenten",
    //   slug: "documents",
    //   icon: "MailIcon"
    // }
  ]
};

export default state;
